SAPO.Project.Video.play = function(o) {

    //jshint maxcomplexity:30

    'use strict';


    // temporary option overrides
    //o.zoneId = 0;
    /*o.onReady = function(v) {
        v.subscribe('load', function(mt, uri, mimeType, isAd, autoplay) {
            console.log('load', uri, mimeType, isAd, autoplay);
        });

        v.subscribe('metadata_changed', function(mt, md) {
            console.log('metadata_changed', md);
        });

        v.subscribe('state_changed', function(mt, state) {
            console.log('state_changed', state);
        });
    };*/


    /**
     * @module Controllers
     */

    /**
     * Instantiates a video player.
     *
     * You can get `VideoHighEnd` or `VideoNative` according to your device/browser feature support.
     *
     * **WARNING** Notice that the player instance isn't returned immediately!
     *
     * You must either use the `onReady` callback to get the instance or wait for tha `variable` to be populated by the player using the variable option.
     *
     *
     * @function play
     * @param {Object}            o
     * @param {String}            o.video                       video URL or SAPO Vídeos hash
     * @param {String|DOMElement} [o.container]                 container element where the video is placed. can be an id or element. defaults to document.body
     * @param {String}            [o.variable]                  defines the given variable in hosting page (once onReady is called)
     * @param {Number}            [o.zoneId]                    override for sapo sites
     * @param {Boolean}           [o.autoplay]=false            starts playback as soon as possible if true
     * @param {Boolean}           [o.allowPlayPause]=true       allows play/pausing with buttons, clicking or keyboard space bar
     * @param {Boolean}           [o.allowResize]=true          makes the toggle fullscreen button available
     * @param {Boolean}           [o.allowScrub]=true           displays a time slider
     * @param {Boolean}           [o.allowVolume]               displays volume slider. true in desktop, false in mobile
     * @param {Boolean}           [o.allowKeyboard]             supports keyboard shorcts. true in desktop, false in mobile
     * @param {Boolean}           [o.followSuggestionsInline]   if true, suggestions are loaded in the same player
     * @param {String}            [o.hashZoneId]                requirement md5 with secret salt so zoneId option gets accepted (otherwise it is discarded)
     * @param {Boolean}           [o.hideInfo]=false            if true, video title and author aren't displayed
     * @param {Object}            [o.i18n]                      overrides for the default language strings defined in i18n.js
     * @param {Boolean}           [o.mute]=false                if true, player starts muted
     * @param {Boolean}           [o.noSapoVideos]=false        if true, disable SAPO Videos Workflow and endpoints
     * @param {String}            [o.quality]                   if set with 'hd' or 'sd', tries to use the given version and hides the quality toggle button
     * @param {String}            [o.relatedVideos]             overrides suggestions mode. supports 'all', 'user' and 'none'
     * @param {Boolean}           [o.skipBranding]=false        if true SAPO button won't appear
     * @param {Boolean}           [o.skipShare]=false           share dialog won't be available if true
     * @param {Boolean}           [o.skipSuggestions]=false     if true no suggestions appear at the end of the video
     * @param {Boolean}           [o.skipSVAnalytics]=false     if true no analytics will be sent to SAPO Videos
     * @param {Boolean}           [o.staticGUI]=false           if true the GUI bar is always visible and won't overlay the video
     * @param {String}            [o.trackUrl]                  if defined, clicking on the SAPO logo/video link takes you to the given url
     * @param {Number}            [o.volume]                    if a number between 0 and 1 is passed, initial player volume is the given number
     * @param {Function}          [o.onReady]                   called once player is fully instanted, passing on the player instance
     * @param {Function}          [o.onError]                   called with parameters player instance and error reason. if ommitted, a default view is rendered in place with the message contents.
     */


    var SPV = SAPO.Project.Video;
    var usingNative = SPV._kind === 'VideoNative';



    // arguments parsing

    if (typeof o === 'string') {
        o = {video:o};
    }

    if ('zoneId' in o && typeof o.zoneId === 'string') {
        o.zoneId = parseInt(o.zoneId, 10);
        if (isNaN(o.zoneId)) {
            delete o.zoneId;
        }
    }

    if ('volume' in o) {
        if (!isFinite(o.volume)) {
            delete o.volume;
        }
        if      (o.volume < 0) { o.volume = 0; }
        else if (o.volume > 1) { o.volume = 1; }
    }

    if (!!o.playerInterno) { // playerInterno has staticGUI by default
        if (!('staticGUI' in o)) { o.staticGUI = true; }
    }
    else { // playerNOTinterno has followSuggestionsInline by default
        if (!('followSuggestionsInline' in o)) { o.followSuggestionsInline = true; }
    }

    var ua = navigator.userAgent.toLowerCase();
    var isIPhoneOrIPod = /iphone|ipod/g.test(ua); // overrides for iPhone/iPod
    if (isIPhoneOrIPod) {
        o.allowResize = false;
    }

    if (o.noSapoVideos) {
        o.relatedVideos   = false;
        o.skipBranding    = true;
        o.skipShare       = true;
        o.skipSuggestions = true;
        o.skipSVAnalytics = true;
    }

    var v = new SPV.Controllers.Video(o);

    // instance variable?
    if (o.variable) {
        var w = usingNative ? window : window.parent;
        w[ o.variable ] = v;
    }



    return usingNative ? undefined : v; // TEMP?
};
